module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_blur.a7211246.jpg";